var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinimize = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.48H.5c-.28 0-.52.24-.52.52s.24.52.52.52h15c.28 0 .52-.23.52-.52s-.24-.52-.52-.52z"
  })));
};
export { SvgMinimize as ReactComponent };
export default "data:image/svg+xml,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' width='16' height='16' %3e %3cpath d='M15.5,7.48h-15C0.22,7.48-0.02,7.72-0.02,8S0.22,8.52,0.5,8.52h15c0.28,0,0.52-0.23,0.52-0.52S15.78,7.48,15.5,7.48z'/%3e %3c/svg%3e";